import React, { useState } from "react";
import { FiChevronsDown, FiChevronsUp } from "react-icons/fi";
import api from "../../../../utils/api";
import { toast } from "react-toastify";
import { Tooltip, tooltipClasses } from "@mui/material";
import { useSelector } from "react-redux";
import { MODULES } from "../../../../core/data/constants/moduleConstants";
import {
  CALLER,
  COMPANY_ADMIN,
  SUPER_ADMIN,
} from "../../../../core/data/constants/constant";
import { useCallHandler } from "../../../../utils/hooks/useCallHandler";
import { convertToUTCString } from "../../../../utils/helpers/helper";
import SocialMediaIcons from "../../../../core/common/crmComponents/SocialMediaIcons";

const DuplicateLeadDetailsSidebar = ({ leadData: lead }) => {
  const [openAccordion, setOpenAccordion] = useState(true);
  const { user } = useSelector((state) => state?.auth);

  const { mutate, isPending, isSuccess, isError } = useCallHandler(
    MODULES.LEADS,
    lead?._id
  );
  const isUserCaller =
    user?.role?.name === CALLER ||
    user?.role?.name === SUPER_ADMIN ||
    user?.role?.name === COMPANY_ADMIN;

  const toggleAccordion = () => {
    setOpenAccordion(!openAccordion);
  };

  return (
    <div className="col-12 theiaStickySidebar">
      <div className="card">
        <div className="card-body p-3">
          <div className="d-flex justify-content-between align-items-center">
            {/* Status Information */}
            <h6 className="mb-1 fw-semibold fs-5 text-decoration-underline">
              Status
            </h6>

            <Tooltip
              title={openAccordion ? "Collapse Details" : "Expand Details"}
            >
              <div style={{ cursor: "pointer" }} onClick={toggleAccordion}>
                {openAccordion ? (
                  <FiChevronsUp size={18} />
                ) : (
                  <FiChevronsDown size={18} />
                )}
              </div>
            </Tooltip>
          </div>

          <div className="row mb-3 gx-5">
            {lead?.currentStatus?.name && (
              <div className="d-flex justify-content-between col-md-6">
                <span className="col-6 fw-bold">Current Status:</span>
                <span className="col-6 text-capitalize">
                  {lead?.currentStatus?.name}
                </span>
              </div>
            )}
            <div className="d-flex justify-content-between col-md-6">
              <span className="col-6 text-capitalize fw-bold">
                Probability:
              </span>
              <span className="col-6 text-capitalize">
                {lead?.probability || "N/A"}
              </span>
            </div>
          </div>
          <hr />

          {openAccordion && (
            <>
              {/* Interested Product */}
              <h6 className="mb-1 fw-semibold fs-5 text-decoration-underline">
                Interested Product
              </h6>
              <div className="row mb-2 ">
                <div className="d-flex justify-content-between col-md-6">
                  <span className="col-6 fw-bold">Product Category:</span>
                  <span className="col-6 text-capitalize">
                    {lead?.productCategory || lead?.productCategory || "N/A"}
                  </span>
                </div>
                <div className="d-flex justify-content-between col-md-6">
                  <span className="col-6 fw-bold">Product Name:</span>
                  <span className="col-6 text-capitalize">
                    {lead?.productInterested?.name ||
                      lead?.productInterested ||
                      "N/A"}
                  </span>
                </div>
              </div>
              <hr />

              {/* Additional Information */}
              <h6 className="mb-1 fw-semibold fs-5 text-decoration-underline ">
                Additional Information
              </h6>
              <ul className="row mb-3">
                <li className="col-md-6 d-flex justify-content-between">
                  <span className="col-6 fw-bold">Campaign Name:</span>
                  <span className="col-6 text-capitalize">
                    {lead?.campaignName || "N/A"}
                  </span>
                </li>

                <li className="col-md-6 d-flex justify-content-between">
                  <span className="col-6 fw-bold">Question 1:</span>
                  <span className="col-6 text-capitalize">
                    {lead?.question1 || "N/A"}
                  </span>
                </li>

                <li className="col-md-6 d-flex justify-content-between">
                  <span className="col-6 fw-bold">Lead Source</span>
                  <span className="col-6 text-capitalize">
                    {lead?.leadSource || "N/A"}
                  </span>
                </li>

                <li className="col-md-6 d-flex justify-content-between">
                  <span className="col-6 fw-bold">Question 2:</span>
                  <span className="col-6 text-capitalize">
                    {lead?.question2 || "N/A"}
                  </span>
                </li>

                <li className="col-md-6 d-flex justify-content-between">
                  <span className="col-6 fw-bold">Reference Source</span>
                  <span className="col-6 text-capitalize">
                    {lead?.referenceSource || "N/A"}
                  </span>
                </li>

                <li className="col-md-6 d-flex justify-content-between">
                  <span className="col-6 fw-bold">Question 3:</span>
                  <span className="col-6 text-capitalize">
                    {lead?.question3 || "N/A"}
                  </span>
                </li>

                <li className="col-md-6 d-flex justify-content-between">
                  <span className="col-6 fw-bold">Language:</span>
                  <span className="col-6 text-capitalize">
                    {lead?.language || "N/A"}
                  </span>
                </li>
                <li className="col-md-6 d-flex justify-content-between">
                  <span className="col-6 fw-bold">User Create Type:</span>
                  <span className="col-6 text-capitalize">
                    {lead?.userCreateType || "N/A"}
                  </span>
                </li>
              </ul>

              <ul className="row mb-3">
                <li className="col-md-6 d-flex justify-content-between">
                  <span className="col-6 fw-bold">Business Type:</span>
                  <span className="col-6 text-capitalize">
                    {lead?.businessType || "N/A"}
                  </span>
                </li>
                <li className="col-md-6 d-flex justify-content-between">
                  <span className="col-6 fw-bold">Reminder Date:</span>
                  <span className="col-6 text-capitalize">
                    {(lead?.reminderDate &&
                      convertToUTCString(lead?.reminderDate)) ||
                      "N/A"}
                  </span>
                </li>
                <li className="col-md-6 d-flex justify-content-between">
                  <span className="col-6 fw-bold">Alternate Number:</span>
                  <span className="col-6 text-capitalize">
                    {lead?.alternateNumber || "N/A"}
                  </span>
                </li>
                <li className="col-md-6 d-flex justify-content-between">
                  <span className="col-6 fw-bold">Client Code:</span>
                  <span className="col-6 text-capitalize">
                    {lead?.clientCode || "N/A"}
                  </span>
                </li>
                <li className="col-md-6 d-flex justify-content-between">
                  <span className="col-6 fw-bold">Occupation:</span>
                  <span className="col-6 text-capitalize">
                    {lead?.occupation || "N/A"}
                  </span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Preferred Language:</span>
                  <span className="col-6 text-capitalize">
                    {lead?.language || "N/A"}
                  </span>
                </li>
                <li className="col-md-6 d-flex justify-content-between">
                  <span className="col-6 fw-bold">City:</span>
                  <span className="col-6 text-capitalize">
                    {lead?.city || lead?.address?.city || "N/A"}
                  </span>
                </li>
                <li className="col-md-6 d-flex justify-content-between">
                  <span className="col-6 fw-bold">State:</span>
                  <span className="col-6 text-capitalize">
                    {lead?.state || lead?.address?.state || "N/A"}
                  </span>
                </li>

                <li className="col-md-6 d-flex justify-content-between">
                  <span className="col-6 fw-bold">Company:</span>
                  <span className="col-6 text-capitalize">
                    {lead?.ofCompany?.name}
                  </span>
                </li>
                <li className="col-md-6 d-flex justify-content-between">
                  <span className="col-6 fw-bold">Last Modified:</span>
                  <span className="col-6">
                    {convertToUTCString(lead?.lastActivityDate)}
                  </span>
                </li>
              </ul>

              <ul className="row mb-3">
                <li className="col-md-6 d-flex justify-content-between">
                  <span className="col-6 fw-bold">Reference Source:</span>
                  <span className="col-6 text-capitalize">
                    {lead?.referenceSource || "N/A"}
                  </span>
                </li>
                <li className="col-md-6 d-flex justify-content-between">
                  <span className="col-6 fw-bold">
                    Reference By Franchise Code:
                  </span>
                  <span className="col-6 text-capitalize">
                    {lead?.referenceByFranchiseCode || "N/A"}
                  </span>
                </li>
                <li className="col-md-6 d-flex justify-content-between">
                  <span className="col-6 fw-bold">
                    Reference By Franchise Mobile:
                  </span>
                  <span className="col-6 text-capitalize">
                    {lead?.referenceByFranchiseMobile || "N/A"}
                  </span>
                </li>
                <li className="col-md-6 d-flex justify-content-between">
                  <span className="col-6 fw-bold">
                    Reference By Franchise Email:
                  </span>
                  <span className="col-6 text-capitalize">
                    {lead?.referenceByFranchiseEmail || "N/A"}
                  </span>
                </li>
                <li className="col-md-6 d-flex justify-content-between">
                  <span className="col-6 fw-bold">
                    Reference By Franchise Name:
                  </span>
                  <span className="col-6 text-capitalize">
                    {lead?.referenceByFranchiseName || "N/A"}
                  </span>
                </li>
                <li className="col-md-6 d-flex justify-content-between">
                  <span className="col-6 fw-bold">Franchise Details:</span>
                  <span className="col-6 text-capitalize">
                    {lead?.franchiseDetails || "N/A"}
                  </span>
                </li>
                <li className="col-md-6 d-flex justify-content-between">
                  <span className="col-6 fw-bold">Franchise RM:</span>
                  <span className="col-6 text-capitalize">
                    {lead?.franchiseRM || "N/A"}
                  </span>
                </li>
              </ul>

              <h6 className="mb-1 fw-semibold fs-5 text-decoration-underline">
                Marketing Information
              </h6>
              <ul className="row mb-3">
                {/* UTM fields */}
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">UTM Medium:</span>
                  <span className="col-6 text-capitalize">
                    {lead?.utmMedium || "N/A"}
                  </span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">UTM Source:</span>
                  <span className="col-6 text-capitalize">
                    {lead?.utmSource || "N/A"}
                  </span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">UTM Content:</span>
                  <span className="col-6 text-capitalize">
                    {lead?.utmContent || "N/A"}
                  </span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">UTM Term:</span>
                  <span className="col-6 text-capitalize">
                    {lead?.utmTerm || "N/A"}
                  </span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">UTM Campaign:</span>
                  <span className="col-6 text-capitalize">
                    {lead?.utmCampaign || "N/A"}
                  </span>
                </li>

                {/* Other marketing info */}
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Data Sources:</span>
                  <span className="col-6 text-capitalize">
                    {lead?.dataSources || "N/A"}
                  </span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">IP Address:</span>
                  <span className="col-6">{lead?.ipAddress || "N/A"}</span>
                </li>

                {/* Social/Ads info */}
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Ad Account:</span>
                  <span className="col-6">{lead?.adAccount || "N/A"}</span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Ad Campaign:</span>
                  <span className="col-6">{lead?.adCampaign || "N/A"}</span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Ad Set:</span>
                  <span className="col-6">{lead?.adSet || "N/A"}</span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Ads:</span>
                  <span className="col-6">{lead?.ads || "N/A"}</span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Lead Form:</span>
                  <span className="col-6">{lead?.leadForm || "N/A"}</span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Facebook Page:</span>
                  <span className="col-6">{lead?.facebookPage || "N/A"}</span>
                </li>

                {/* IDs */}
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Ad Account ID:</span>
                  <span className="col-6">{lead?.adAccountId || "N/A"}</span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Ad Campaign ID:</span>
                  <span className="col-6">{lead?.adCampaignId || "N/A"}</span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Ad Set ID:</span>
                  <span className="col-6">{lead?.adSetId || "N/A"}</span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Ad ID:</span>
                  <span className="col-6">{lead?.adId || "N/A"}</span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Lead Form ID:</span>
                  <span className="col-6">{lead?.leadFormId || "N/A"}</span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Facebook Page ID:</span>
                  <span className="col-6">{lead?.facebookPageId || "N/A"}</span>
                </li>

                {/* Extra business/social fields */}
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Brand:</span>
                  <span className="col-6">{lead?.brand || "N/A"}</span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Lead ID (Social):</span>
                  <span className="col-6">{lead?.leadIdSocial || "N/A"}</span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Business Lead Type:</span>
                  <span className="col-6">
                    {lead?.businessLeadType || "N/A"}
                  </span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Platform:</span>
                  <span className="col-6">{lead?.platform || "N/A"}</span>
                </li>
              </ul>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default DuplicateLeadDetailsSidebar;
